webpackJsonp([248746927833720],{

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FreeReign = function FreeReign(props) {
	  var html = props.html,
	      id = props.id;
	
	  return _react2.default.createElement(_Typography2.default, {
	    id: id,
	    component: 'div',
	    dangerouslySetInnerHTML: { __html: html }
	  });
	};
	
	FreeReign.propTypes = {
	  html: _propTypes2.default.string.isRequired,
	  id: _propTypes2.default.string.isRequired
	};
	
	exports.default = FreeReign;
	module.exports = exports['default'];

/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Divider = __webpack_require__(210);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _thumbnail, _downloadBtn, _title;
	
	  return {
	    thumbnail: (_thumbnail = {
	      float: 'left',
	      margin: '0 30px 10px',
	      display: 'block',
	      objectFit: 'cover'
	    }, _thumbnail[theme.breakpoints.down('sm')] = {
	      float: 'none',
	      margin: 'auto',
	      maxWidth: '100%',
	      height: '100%',
	      maxHeight: '100vh'
	    }, _thumbnail),
	    downloadBtn: (_downloadBtn = {
	      color: '#fff',
	      background: theme.palette.text.review,
	      '&:hover': {
	        background: theme.palette.primary.main
	      }
	    }, _downloadBtn[theme.breakpoints.down('xs')] = {
	      fontSize: '0.85em'
	    }, _downloadBtn),
	    title: (_title = {
	      padding: 12,
	      fontWeight: 600,
	      color: theme.palette.primary.main,
	      paddingTop: 10
	    }, _title[theme.breakpoints.down('xs')] = {
	      fontSize: '1.4em'
	    }, _title)
	  };
	};
	
	var OnePageFunnel = function OnePageFunnel(props) {
	  var header = props.header,
	      body = props.html;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Typography2.default,
	      { variant: 'headline', align: 'center' },
	      header
	    ),
	    _react2.default.createElement(_Typography2.default, { component: 'div', dangerouslySetInnerHTML: { __html: body } })
	  );
	};
	
	OnePageFunnel.propTypes = {
	  slug: _propTypes2.default.string.isRequired,
	  html: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  header: _propTypes2.default.string.isRequired,
	  video: _propTypes2.default.string.isRequired,
	  landingUrl: _propTypes2.default.string.isRequired,
	  thumbnail: _propTypes2.default.string.isRequired,
	  bonus1: _propTypes2.default.string,
	  bonus2: _propTypes2.default.string,
	  bonus3: _propTypes2.default.string,
	  ending: _propTypes2.default.string
	};
	
	exports.default = (0, _withStyles2.default)(styles)(OnePageFunnel);
	module.exports = exports['default'];

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Page = __webpack_require__(934);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _FreeReign = __webpack_require__(926);
	
	var _FreeReign2 = _interopRequireDefault(_FreeReign);
	
	var _OnePageFunnel = __webpack_require__(927);
	
	var _OnePageFunnel2 = _interopRequireDefault(_OnePageFunnel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LandingView = function LandingView(props) {
	  var landingType = props.landingType,
	      restProps = _objectWithoutProperties(props, ['landingType']);
	
	  var view = void 0;
	
	  if (landingType === 'free-reign') {
	    view = _react2.default.createElement(_FreeReign2.default, _extends({ id: 'landingPage' }, restProps));
	    return view;
	  }
	
	  if (landingType === 'one-page-funnel') {
	    view = _react2.default.createElement(_OnePageFunnel2.default, restProps);
	  }
	
	  return _react2.default.createElement(
	    _Page2.default,
	    { id: 'landingPage' },
	    _react2.default.createElement(
	      _Page2.default.Section,
	      null,
	      view
	    )
	  );
	};
	
	LandingView.propTypes = {
	  slug: _propTypes2.default.string.isRequired,
	  html: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string,
	  header: _propTypes2.default.string,
	  video: _propTypes2.default.string,
	  landingUrl: _propTypes2.default.string.isRequired,
	  date: _propTypes2.default.string.isRequired,
	  thumbnail: _propTypes2.default.string,
	  shortDescription: _propTypes2.default.string,
	  tags: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  landingType: _propTypes2.default.string.isRequired,
	  bonus1: _propTypes2.default.any,
	  bonus2: _propTypes2.default.any,
	  bonus3: _propTypes2.default.any,
	  ending: _propTypes2.default.any
	};
	
	exports.default = LandingView;
	module.exports = exports['default'];

/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Page = function Page(_ref) {
	  var children = _ref.children,
	      style = _ref.style,
	      props = _objectWithoutProperties(_ref, ['children', 'style']);
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    _extends({
	      style: _extends({ padding: '20px 0 40px' }, style),
	      spacing: 24,
	      justify: 'center',
	      alignItems: 'center'
	    }, props, {
	      container: true
	    }),
	    children
	  );
	};
	
	Page.Section = function (props) {
	  return _react2.default.createElement(_Grid2.default, _extends({}, props, { item: true }));
	};
	
	Page.propTypes = {
	  children: _propTypes2.default.any.isRequired,
	  style: _propTypes2.default.object
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Meta = __webpack_require__(48);
	
	var _Landing = __webpack_require__(928);
	
	var _Landing2 = _interopRequireDefault(_Landing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LandingTemplate = function LandingTemplate(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  var articleBody = pathContext.articleBody;
	  var post = data.post,
	      file = data.file;
	
	
	  var datePublished = new Date(post.frontmatter.date).toISOString();
	  var dateModified = file.modifiedTime;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Meta.ArticleMeta, {
	      title: post.frontmatter.title,
	      shortDescription: post.frontmatter.shortDescription,
	      thumbnail: post.frontmatter.thumbnail,
	      genre: 'health',
	      tags: post.frontmatter.tags,
	      wordCount: post.wordCount.words,
	      datePublished: datePublished,
	      dateModified: dateModified,
	      articleBody: articleBody,
	      excerpt: post.excerpt,
	      path: post.fields.slug
	    }),
	    _react2.default.createElement(_Landing2.default, _extends({
	      html: post.html,
	      slug: post.fields.slug
	    }, post.frontmatter))
	  );
	};
	
	LandingTemplate.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.shape({
	    articleBody: _propTypes2.default.string.isRequired
	  }).isRequired
	
	  // eslint-disable-next-line
	};var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = LandingTemplate;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-landing-js-45c477cefaedf331212d.js